import React, { useState, useEffect } from "react";
import Sidebar from "../Components/Sidebar";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { fetchAllowedMenus, fetchCityData } from "../Services/APIService";
import CreateCity from "../Components/CreateCity";
import CityView from "../Components/CityView";
import UpdateCity from "../Components/UpdateCity";
import CollapsibleSidebar from "../Components/CollapsibleSidebar";
import { useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";

interface MenuItem {
  menuID: number;
  menuName: string;
  menuUrl: string;
  icon: string;
  subMenuList?: [];
}

interface viewdata {
  stateId: number;
  stateName: string;
  isActive: boolean;
  districtId: number;
  districtName: string;
  cityId: number;
  cityName: string;
}

const Cities: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [allowedMenus, setAllowedMenus] = useState<MenuItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showCreateCard, setShowCreateCard] = useState(false);
  const [showUpdateCard, setShowUpdateCard] = useState(false);
  const [selectedViewData, setselectedViewData] = useState<viewdata | null>(
    null
  );
  const [viewdatas, setviewdatas] = useState<viewdata[]>([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const location = useLocation();

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  // Function to toggle create form
  const toggleCreateForm = () => {
    setShowCreateCard(!showCreateCard);
    // Hide update form if it's open
    if (showUpdateCard) {
      setShowUpdateCard(false);
      setselectedViewData(null);
    }
  };

  // Function to handle edit button click from CityView
  const handleEdit = (viewdata: viewdata) => {
    setselectedViewData(viewdata);
    setShowUpdateCard(true);
    // Hide create form if it's open
    if (showCreateCard) {
      setShowCreateCard(false);
    }
    // Scroll to the update card
    setTimeout(() => {
      const updateCard = document.getElementById("updateGroupCard");
      if (updateCard) {
        updateCard.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  // Function to handle create completion
  const handleCreateComplete = () => {
    setShowCreateCard(false);
    refreshGroups();
  };

  // Function to handle create cancel
  const handleCreateCancel = () => {
    setShowCreateCard(false);
  };

  // Function to handle update completion
  const handleUpdateComplete = () => {
    setShowUpdateCard(false);
    setselectedViewData(null);
    refreshGroups();
  };

  // Function to handle update cancel
  const handleUpdateCancel = () => {
    setShowUpdateCard(false);
    setselectedViewData(null);
  };

  // Function to refresh groups data
  const refreshGroups = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  // Fetch menu data
  useEffect(() => {
    const getMenus = async () => {
      setIsLoading(true);
      try {
        const menuID = location.state?.menuID;
        const previousMenuID = localStorage.getItem("activeMenuID");
        if (menuID !== previousMenuID || menuID === null) {
          localStorage.setItem("activeMenuID", menuID);
        } else {
          localStorage.removeItem("activeMenuID");
        }
      } catch (error) {
        console.error("Error fetching menus:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getMenus();
  }, []);

  // Fetch groups data
  useEffect(() => {
    const getGroups = async () => {
      try {
        const fetchViewData = await fetchCityData();
        setviewdatas(fetchViewData);
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    };

    getGroups();
  }, [refreshTrigger]); // Re-fetch when refreshTrigger changes

  return (
    <div className="wrapper">
      {!isSidebarCollapsed && <CollapsibleSidebar />}
      <div className="main">
       
        <Navbar onToggleSidebar={toggleSidebar} />
        <div className="main-content-div">
          <div className="main-header-div"></div>
          <main className="content mainContent">
            <div className="container-fluid p-0">
              <div className="row">
                <div className="col-12 col-lg-12">
                  {showCreateCard && (
                    <CreateCity
                      onCreateComplete={handleCreateComplete}
                      onCancel={handleCreateCancel}
                    />
                  )}

                  {showUpdateCard && (
                    <div id="updateGroupCard">
                      <UpdateCity
                        viewData={selectedViewData}
                        onUpdateComplete={handleUpdateComplete}
                        onCancel={handleUpdateCancel}
                      />
                    </div>
                  )}
                </div>
                <div className="col-12 col-lg-12">
                  <CityView
                    viewData={viewdatas}
                    onEdit={handleEdit}
                    onAddClick={toggleCreateForm}
                    showAddButton={!showCreateCard && !showUpdateCard}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Cities;
